import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Home from './views/Home.vue'
import PostList from './views/PostList'
import Post from './views/Post'
import Article from './views/Article'
import Login from "./components/admin/login.vue";
import Posts from "./components/admin/posts/Posts.vue";
import Drafts from "./components/admin/posts/Drafts.vue";
import PostDetails from "./components/admin/posts/partials/PostDetails.vue";

const router = new VueRouter({
    mode: 'history',
    routes: [
        //admin
        {
            path: '/a/b/c',
            name: 'login',
            component: Login
        },
        {
            path: '/a/login',
            name: 'login',
            component: Login
        },
        {
            path: '/a/posts',
            name: 'posts',
            component: Posts
        },
        {
            path: '/a/posts/drafts',
            name: 'drafts',
            component: Drafts
        },
        {
            path: '/a/posts/:id',
            name: 'postDetails',
            component: PostDetails
        },
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/jogi-nyilatkozat',
            name: 'jogi_nyilatkozat',
            component: Article,
            props: {
                shortname: 'jogi_nyilatkozat'
            }
        },
        {
            path: '/impresszum',
            name: 'impresszum',
            component: Article,
            props: {
                shortname: 'impresszum'
            }
        },
        {
            path: '/kapcsolat',
            name: 'kapcsolat',
            component: Article,
            props: {
                shortname: 'kapcsolat'
            }
        },
        {
            path: '/sutik',
            name: 'sutik',
            component: Article,
            props: {
                shortname: 'sutik'
            }
        },
        {
            path: '/kereses/:q',
            name: 'search',
            component: PostList,
            props: {
                type: 'search',
            },
            params: {
                page: 'page',
            }
        },
        {
            path: '/kereses/:menu_path/:tag',
            name: 'tag_search',
            component: PostList,
            props: {
                type: 'tag_search',
            },
            params: {
                page: 'page',
            }
        },
        {
            path: '/:menu_path',
            name: 'postList',
            component: PostList,
            params: {
                page: 'page',
            }
        },
        {
            path: '/:menu_path/:post_shortname',
            name: 'post',
            component: Post
        },
    ]
})

export default router;
